/** Textes d'aide pour l'administration itiConseil et Koikispass. */

export const ADMIN_FIELD_HELP = {
  validFromYear: {
    help: 'Année à partir de laquelle cette valeur est proposée dans les formulaires et plannings.',
    helpExample: '2026 — la valeur apparaît dès janvier 2026.',
  },
  validFromMonth: {
    help: 'Premier mois où la valeur est active. Utile pour une montée de tarifs en cours d\'année.',
    helpExample: 'Juillet — le nouveau tarif s\'applique à partir de juillet.',
  },
  productRef: {
    help: 'Référence produit Dolibarr liée à ce format. Sert au bon de commande et à la facturation.',
    helpExample: 'TME01 — doit correspondre à un produit existant dans Dolibarr.',
  },
  validityStatus: {
    help: 'Actif = utilisable maintenant. Programmé = entrera en vigueur plus tard. Expiré / Inactif = plus proposé aux commerciaux.',
  },
  magFormatLabel: {
    help: 'Nom affiché dans le chemin de fer magazine et les listes déroulantes.',
    helpExample: '1/2 PAGE, CARRE 1 G, DOUBLE PAGE…',
  },
  magFormatDispo: {
    help: 'Nombre de lignes vides créées chaque mois dans l’onglet Dispos du planning. 0 n’en crée aucune.',
    helpExample: '5 = cinq lignes « Bandeau Immo » proposées chaque mois.',
  },
  magContenuLabel: {
    help: 'Rubrique éditoriale du magazine (Monde Food, Terroir, etc.).',
    helpExample: 'MONDE FOOD, TERROIR, ACTUALITE…',
  },
  setFormatLabel: {
    help: 'Format de l\'agenda SET. Chaque format actif génère une ligne par mois dans le planning.',
    helpExample: 'CARRE 1 G, BANDEAU…',
  },
  nlSlot: {
    help: 'Emplacement publicitaire dans la newsletter (pavé, bannière…).',
    helpExample: 'PAVE MIDDLE, BANDEAU TOP…',
  },
  nlTypeCode: {
    help: 'Code court du type de newsletter, utilisé en interne.',
    helpExample: 'FOOD, SORTIES, VINS…',
  },
  nlPrefix: {
    help: 'Préfixe affiché dans le planning pour identifier rapidement le type.',
    helpExample: 'NEWS FOOD, NEWS VINS…',
  },
  nlWeekday: {
    help: 'Jour d\'envoi habituel de ce type de newsletter.',
    helpExample: 'Vendredi pour une newsletter hebdomadaire.',
  },
  nlDispoMax: {
    help: 'Nombre maximum d\'envois de ce type par mois dans le planning.',
    helpExample: '1 = un seul créneau « 1er uniquement » par mois.',
  },
  statutLabel: {
    help: 'Libellé affiché dans les plannings MAG, SET et Newsletters.',
    helpExample: 'En cours, Option, Vendu OK…',
  },
  statutCouleur: {
    help: 'Couleur de fond des cellules dans les grilles de vente. Choisissez une couleur bien visible.',
  },
  tarifLibelle: {
    help: 'Nom du tarif tel qu\'il apparaît dans le chiffrage Plan de Com.',
    helpExample: 'Page magazine, Encart web, Package…',
  },
  tarifCategorie: {
    help: 'Regroupe les tarifs dans le chiffrage (magazine, web, frais…).',
  },
  tarifOrdre: {
    help: 'Ordre d\'affichage dans les listes. Les petits nombres apparaissent en premier.',
    helpExample: '10, 20, 30…',
  },
  fraisLibelle: {
    help: 'Nom du frais technique tel qu\'il apparaît dans le chiffrage Plan de Com.',
    helpExample: 'PAGE PUBLI REDAC, Prise de photos, Déplacement hors agglo…',
  },
  produitBdcCode: {
    help: 'Code court du produit sur le bon de commande PDF.',
    helpExample: 'MAG-01, WEB-BAN…',
  },
  produitBdcLibelle: {
    help: 'Libellé imprimé sur le bon de commande PDF.',
    helpExample: 'Page magazine, Encart web, Package newsletter…',
  },
  klubNom: {
    help: 'Nom de l\'offre Klub telle qu\'elle apparaît dans l\'administration et les grilles tarifaires.',
    helpExample: 'KLUB PREMIUM, KLUB CE…',
  },
};

export const ITI_ADMIN_HELP = {
  variables: {
    description: 'Ces paramètres alimentent le moteur de chiffrage site internet. Toute modification impacte les prochains devis — les chiffrages déjà enregistrés conservent leurs montants.',
    steps: [
      { title: 'Modifier une valeur', text: 'changez le tarif ou la durée directement dans le tableau.' },
      { title: 'Augmenter en groupe', text: 'utilisez le panneau rouge pour appliquer la même hausse à plusieurs tarifs en euros.' },
      { title: 'Enregistrer', text: 'cliquez sur « Enregistrer » en haut à droite du tableau — rien n\'est sauvegardé tant que vous ne validez pas.' },
    ],
    tips: [
      'Les montants en euros (€) peuvent être augmentés en groupe. Les durées en heures (h) se modifient une par une.',
      'Passez la souris sur l\'icône ℹ à côté d\'un libellé pour comprendre son rôle dans le chiffrage.',
    ],
    warning: 'Pensez à enregistrer après vos modifications. Si vous quittez la page sans enregistrer, vos changements seront perdus.',
  },
};

/** Aide contextuelle par clé de variable ITI (tooltips dans le tableau). */
export const ITI_VARIABLE_HELP = {
  CoutHoraire: { help: 'Tarif horaire de base pour convertir les durées en montants.' },
  TarifHebergement: { help: 'Abonnement annuel hébergement proposé dans le chiffrage.' },
  PrixNDDAnnuel: { help: 'Abonnement annuel nom de domaine principal.' },
  CoutGoogleAvisPayant: { help: 'Abonnement annuel module avis Google payant.' },
  SEOTrimestriel: { help: 'Forfait annuel contrat SEO trimestriel.' },
  SEOSemestriel: { help: 'Forfait annuel contrat SEO semestriel.' },
  CoutTransfertNomDeDomaine: { help: 'Forfait transfert d\'un nom de domaine existant.' },
  CoutAdressesEmails: { help: 'Abonnement annuel par boîte e-mail.' },
  TarifReportagePhoto: { help: 'Forfait reportage photo (facturation prestataire en sus).' },
  CoutCessionAjustementsGraphiques: { help: 'Forfait par session d\'ajustements graphiques.' },
  CoutCessionAjustementsContenus: { help: 'Forfait par session d\'ajustements de contenus.' },
  TraductionCoutAuMot: { help: 'Tarif de traduction au mot.' },
};

export const KKP_ADMIN_HELP = {
  mag: {
    description: 'Référentiels du chemin de fer magazine : formats publicitaires et rubriques éditoriales (contenus).',
    steps: [
      { title: 'Ajouter', text: 'remplissez le formulaire puis cliquez sur « Ajouter ».' },
      { title: 'Désactiver', text: 'masque une valeur à partir d\'un mois donné sans effacer l\'historique.' },
      { title: 'Supprimer', text: 'efface définitivement — à réserver aux erreurs de saisie.' },
    ],
    tips: [
      'Préférez « Désactiver » plutôt que « Supprimer » : l\'historique des ventes est conservé.',
      'La référence produit Dolibarr n\'est nécessaire que pour les formats (facturation).',
    ],
    tabs: {
      formats: {
        description: 'Formats publicitaires du magazine. « Dispos / mois » fixe le nombre de lignes vides créées automatiquement chaque mois dans l’onglet Dispos du planning (0 = aucune).',
      },
      contenus: {
        description: 'Rubriques éditoriales du magazine (Monde Food, Terroir…). Elles structurent les blocs du chemin de fer par contenu.',
      },
    },
  },
  set: {
    description: 'Formats de l\'agenda SET. Chaque format actif ajoute une ligne par mois dans le planning des ventes SET (10 lignes maximum par mois).',
    tips: [
      'Un format désactivé disparaît des nouvelles saisies mais les ventes passées restent visibles.',
      'Utilisez « Actif depuis » pour programmer une montée de gamme tarifaire ou un changement de nomenclature.',
    ],
  },
  newsletter: {
    description: 'Configuration des newsletters : types d\'envoi, emplacements publicitaires et règles de disponibilité mensuelle.',
    steps: [
      { title: 'Types', text: 'définissez les familles de newsletters (FOOD, VINS…) avec leur jour d\'envoi.' },
      { title: 'Emplacements', text: 'ajoutez les slots publicitaires (pavés, bandeaux) rattachés à un type.' },
      { title: 'Disponibilité', text: 'limitez le nombre d\'envois par mois pour chaque type.' },
    ],
    tabs: {
      emplacements: {
        description: 'Slots publicitaires disponibles dans chaque type de newsletter (pavé middle, bandeau top…).',
      },
      types: {
        description: 'Types de newsletters avec leur jour d\'envoi habituel et leur préfixe dans le planning.',
      },
      dispo: {
        description: 'Règles limitant le nombre d\'envois par mois. Utile pour les newsletters « 1er envoi du mois uniquement ».',
      },
    },
  },
  klub: {
    description: 'Offres Klub et Klub CE avec une réf. produit Dolibarr par tranche de salariés. Au chiffrage, l’effectif choisit automatiquement le bon produit et son prix catalogue.',
    tips: [
      'Liez un produit Dolibarr distinct sur chaque tranche (1–10, 11–20, 21–48, 49+) ; le montant suit le catalogue produit_marque.',
      'Les frais d’init gardent une seule réf. (souvent KLUBINIT) et un montant saisi librement (ex. 350 € même si le catalogue est à 200 €).',
      'Utilisez le panneau « Augmenter les tarifs » pour une hausse groupée des montants locaux / frais.',
    ],
  },
  chiffrage: {
    description: 'Tarification du Plan de Com : tarifs média, frais techniques et libellés produits du bon de commande (BDC).',
    steps: [
      { title: 'Tarifs', text: 'montants utilisés dans le chiffrage Koikispass.' },
      { title: 'Frais techniques', text: 'forfaits techniques (graphisme, tracking…).' },
      { title: 'Produits BDC', text: 'libellés imprimés sur le bon de commande PDF.' },
    ],
    tips: [
      'Désactiver un tarif le masque dans les nouveaux chiffrages sans modifier les dossiers existants.',
      'L\'ordre d\'affichage permet de regrouper les tarifs par catégorie dans le chiffrage.',
    ],
    tabs: {
      tarifs: { description: 'Tarifs média et prestations utilisés lors du chiffrage Koikispass.' },
      'frais-techniques': { description: 'Frais techniques (graphisme, tracking, envoi…) ajoutés au chiffrage.' },
      produits: { description: 'Codes et libellés longs des produits sur le bon de commande PDF généré.' },
    },
  },
  statuts: {
    description: 'Statuts de phase communs aux plannings MAG, SET et Newsletters. Ils colorent les cellules et indiquent l\'avancement commercial (option, vendu, annulé…).',
    tips: [
      'La couleur est visible directement dans les grilles de vente — choisissez des couleurs contrastées.',
      'Modifier une couleur prend effet immédiatement après enregistrement.',
      'Ne supprimez un statut que s\'il n\'a jamais été utilisé — sinon préférez la désactivation.',
    ],
  },
  'alertes-cdf': {
    description: 'Déplacé vers la page « Alertes mails » du menu Koikispass.',
    steps: [
      { title: 'Ouvrir Alertes mails', text: 'utilisez le menu Koikispass → Alertes mails.' },
    ],
  },
};

/**
 * @param {string} section
 * @param {string|null} [subTab]
 */
export const getKkpSectionHelp = (section, subTab = null) => {
  const base = KKP_ADMIN_HELP[section];
  if (!base) return {};

  if (subTab && base.tabs?.[subTab]) {
    return {
      ...base,
      description: base.tabs[subTab].description,
      tips: base.tabs[subTab].tips ?? base.tips,
      steps: base.tabs[subTab].steps ?? base.steps,
      warning: base.tabs[subTab].warning ?? base.warning,
    };
  }

  return base;
};

export const getItiSectionHelp = (section) => ITI_ADMIN_HELP[section] ?? {};

export const ADMIN_NAV_TIPS = {
  iti: 'Choisissez une rubrique à gauche. Les modifications ne sont enregistrées qu\'après clic sur « Enregistrer » (variables) ou validation des formulaires (Koikispass).',
  kkp: 'Les plannings utilisent ces référentiels. En cas de doute, désactivez plutôt que supprimez — l\'historique des ventes est conservé.',
};
